import React from 'react';
var PROGRESS_BAR_STYLES = 'absolute top-0 left-0 flex p-1 bg-gray-400 bg-opacity-25 w-full rounded';
var METER_STYLES = 'flex bg-actionable rounded';
export var Progress = function (_a) {
    var _b = _a.progress, progress = _b === void 0 ? 0 : _b;
    return (React.createElement("div", { className: PROGRESS_BAR_STYLES },
        React.createElement("span", { className: METER_STYLES, style: { width: (progress !== null && progress !== void 0 ? progress : 0) + "%", height: '4px' } }),
        React.createElement("progress", { max: "100", value: progress, className: "absolute opacity-0" })));
};
